import { AnyAction } from 'redux';
import { WellnessCalendarState } from '../schema';
import {
  SET_WELLNESS_CALENDAR,
  SET_WELLNESS_CALENDAR_LOADING,
  SET_WELLNESS_CALENDAR_ERROR
} from '../middleware';

const initialState: WellnessCalendarState = {
  data: null,
  loading: false,
  error: null
};

export const wellnessCalendarReducer = (
  state = initialState,
  action: AnyAction
): WellnessCalendarState => {
  switch (action.type) {
    case SET_WELLNESS_CALENDAR:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: null
      };
    case SET_WELLNESS_CALENDAR_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
        error: null
      };
    case SET_WELLNESS_CALENDAR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    default:
      return state;
  }
};
